import { jsx as _jsx } from "react/jsx-runtime";
import { AuthCardContent } from "./card/index.js";
import { useAuthModal } from "../../hooks/useAuthModal.js";
import { Dialog } from "../dialog/dialog.js";
import { useUiConfig } from "../../hooks/useUiConfig.js";
export const AuthModal = () => {
    const { modalBaseClassName } = useUiConfig();
    const { isOpen, closeAuthModal } = useAuthModal();
    return (_jsx(Dialog, { isOpen: isOpen, onClose: closeAuthModal, children: _jsx("div", { className: `modal md:w-[368px] ${modalBaseClassName ?? ""} overflow-hidden`, children: _jsx(AuthCardContent, { showClose: true }) }) }));
};
//# sourceMappingURL=modal.js.map